import React, { Fragment } from 'react'

export const projects = [
  {
    listed: true,
    key: 'turnkey',
    title: 'Turnkey Intelligence',
    headline: 'Keeping the sports experts in the digital game',
    headlineMarkup: (
      <Fragment>
        <span>Keeping the sports</span>
        <br />
        <span>experts in the</span>
        <br />
        <span>digital game</span>
      </Fragment>
    ),
    details: {
      client: 'MarketCast Group Inc.',
      industry: 'Sports & Entertaiment',
      services: [
        'Creative Direction',
        'Website Design',
        'WordPress Development',
        'Social Media Strategy',
      ],
    },
    tags: [
      'Creative Direction',
      'Website Design',
      'Development',
      'Social Content',
    ],
    color: '#ee434a',
    colors: ['#c1424c', '#ee434a'],
  },
  {
    listed: true,
    key: 'motiv-ring',
    title: 'Motiv Ring',
    headline: 'Launching a tech startup',
    headlineMarkup: (
      <Fragment>
        <span>Launching</span>
        <br />
        <span>a tech startup</span>
      </Fragment>
    ),
    details: {
      client: 'Motiv Inc',
      industry: 'Consumer Technology',
      services: [
        'Brand Identity',
        'Website Design',
        'Content Development',
        'Digital Advertising',
      ],
      awards: [
        'American Advertising Awards',
        'The Communicator Awards',
        'dotComm Awards',
        'W3 Awards',
        'Webby Awards',
      ],
    },
    tags: [
      'Brand Identity',
      'Website Design',
      'Content Development',
      'Digital Advertising',
    ],
    color: '#1C1D1F',
    colors: ['#9099a9', '#546073'],
  },
  {
    listed: true,
    key: 'tennis-channel',
    title: 'Tennis Channel',
    headline: "Upgrading tennis' premiere website",
    headlineMarkup: (
      <Fragment>
        <span>Upgrading tennis'</span>
        <br />
        <span>premiere website</span>
      </Fragment>
    ),
    details: {
      client: 'The Tennis Channel',
      agency: 'Something Massive',
      industry: 'Sports & Entertaiment',
      services: ['Website Design'],
    },
    tags: ['UX Design', 'Visual Design'],
    color: '#008568',
    colors: ['#16cc9e', '#038c6a'],
  },
  {
    listed: true,
    key: 'fox-digital',
    title: 'FOX Digital',
    headline: 'Extending the story into social',
    headlineMarkup: (
      <Fragment>
        <span>Extending the</span>
        <br />
        <span>story into social</span>
      </Fragment>
    ),
    details: {
      client: 'FOX Networks Group',
      industry: 'Entertainment',
      services: ['Social Content', 'Digital Advertising'],
    },
    tags: ['Social Content', 'Brand Guidelines'],
    color: '#e6e147',
    colors: ['#4b6fc5', '#213F87'],
  },
  {
    listed: true,
    key: 'amc-preacher',
    title: 'AMC’s Preacher',
    headline: 'Activating fans of a cult classic',
    headlineMarkup: (
      <Fragment>
        <span>Activating fans</span>
        <br />
        <span>of a cult classic</span>
      </Fragment>
    ),
    details: {
      client: 'AMC',
      agency: 'Leroy & Rose',
      industry: 'Entertainment',
      services: ['Social Content', 'Digital Advertising'],
    },
    tags: ['Social Content', 'Digital Advertising'],
    color: '#c87100',
    colors: ['#debb28', '#904000'],
  },
  {
    listed: true,
    key: 'azubu',
    title: 'Azubu',
    headline: 'Leveling up a global eSports brand',
    headlineMarkup: (
      <Fragment>
        <span>Leveling up a</span>
        <br />
        <span>global eSports</span>
        <br />
        <span>brand</span>
      </Fragment>
    ),
    details: {
      client: 'Azubu North America, Inc.',
      industry: 'Sports & Entertainment',
      services: [
        'Brand Strategy',
        'Brand Identity',
        'Mobile App Design',
        'Web Design',
        'Content Development',
        'Digital Advertising',
        'Event Marketing',
      ],
      awards: ['Best Mobile App Awards', '[app] design awards'],
    },
    tags: [
      'Brand Strategy',
      'Creative Direction',
      'Website Design',
      'Social Content',
    ],
    color: '#077dd5',
    colors: ['#077dd5', '#4d1739'],
  },
  {
    listed: true,
    key: 'espn',
    title: 'ESPN',
    headline: 'Hyping up the return of college football',
    headlineMarkup: (
      <Fragment>
        <span>Hyping up the</span>
        <br />
        <span>return of college</span>
        <br />
        <span>football</span>
      </Fragment>
    ),
    details: {
      client: 'ESPN',
      agency: 'RED Interactive',
      industry: 'Entertainment',
      services: ['Visual Design', 'Digital Advertising'],
    },
    tags: ['Visual Design', 'Digital Advertising'],
    color: '#941608',
    colors: ['#781307', '#a8370d'],
  },
  {
    listed: true,
    key: 'lafc',
    title: 'LAFC',
    headline: 'Going Metro with Latif Blessing',
    headlineMarkup: (
      <Fragment>
        <span>Going Metro with</span>
        <br />
        <span>Latif Blessing</span>
      </Fragment>
    ),
    details: {
      client: 'Metro Los Angeles',
      agency: 'Friendly Filmworks',
      industry: 'Transportation',
      services: ['Video Production', 'Creative Direction'],
    },
    tags: ['Video Production', 'Creative Direction'],
    color: '#111',
    colors: ['#333', '#222'],
  },
  {
    listed: true,
    key: 'nestea',
    title: 'Nestea',
    headline: 'Adding flavor to summertime',
    headlineMarkup: (
      <Fragment>
        <span>Adding flavor</span>
        <br />
        <span>to summertime</span>
      </Fragment>
    ),
    details: {
      client: 'Nestlé',
      industry: 'Food & Beverage',
      services: ['Visual Design'],
    },
    tags: ['Brand Architecture', 'Visual Design'],
    color: '#07b0f3',
    colors: ['#047fcd', '#27aad6'],
  },
  {
    listed: true,
    key: 'ac-hotels',
    title: 'AC Hotels',
    headline: 'A hotel for the modern entrepreneur',
    headlineMarkup: (
      <Fragment>
        <span>A hotel for</span>
        <br />
        <span>the modern</span>
        <br />
        <span>entrepreneur</span>
      </Fragment>
    ),
    details: {
      client: 'AC Hotels',
      agency: 'Consensus Inc.',
      industry: 'Hospitality',
      services: ['Creative Direction', 'Website Design'],
    },
    tags: ['Creative Direction', 'Website Design'],
    color: '#c6c4b9',
    colors: ['#c6c4b9', '#c6c4b9'],
  },
  {
    listed: true,
    key: 'dignity-health',
    title: 'Dignity Health',
    headline: 'Empowering Humankindness',
    headlineMarkup: (
      <Fragment>
        <span>Empowering</span>
        <br />
        <span>Humankindness</span>
      </Fragment>
    ),
    details: {
      client: 'Dignity Health',
      agency: 'Dirango',
      industry: 'Health',
      services: ['Website Design'],
    },
    tags: ['Website Design', 'Development'],
    color: '#d6763a',
    colors: ['rgba(239, 116, 24, .9)', 'rgba(255, 132, 40, 0.9)'],
  },
  {
    listed: true,
    key: 'paramount-equity-mortgage',
    title: 'Paramount Equity Mortgage',
    details: {
      client: 'Paramount Equity Mortgage',
      industry: 'Financial',
      services: [
        'Brand Strategy',
        'Brand Messaging',
        'Brand Identity',
        'Web Design + Development',
      ],
    },
    tags: [
      'Brand Strategy',
      'Brand Identity',
      'Website Design',
      'Digital Advertising',
    ],
    color: '#013990',
    colors: ['#43adff', '#013990'],
  },
  {
    listed: true,
    key: 'burbank',
    title: 'iHeartBurbank',
    details: {
      client: 'Burbank Town Center',
      agency: 'Consensus Inc.',
      industry: 'Retail',
      services: [
        'Video Production',
        'Creative Direction',
        'Web Design + Development',
        'Content Development',
      ],
      awards: ['Video Program - Consumer', 'PRISM Awards 2016'],
    },
    tags: ['Visual Design', 'Website Design', 'Video Production'],
    color: '#574a90',
    colors: ['#00c0ed', '#901862'],
  },
  {
    listed: true,
    key: 'aliso-viejo',
    title: 'Aliso Viejo',
    details: {
      client: 'City of Aliso Viejo',
      agency: 'Consensus Inc.',
      industry: 'Government',
      services: ['Video Production', 'Website Design + Development'],
      awards: [
        'Award of Excellence',
        'Video Program - Government',
        'PRISM Awards 2017',
      ],
    },
    tags: ['Visual Design', 'Website Design', 'Video Production'],
    color: '#00597f',
    colors: ['#00c5bb', '#00597f'],
  },
  {
    listed: true,
    key: 'press-pops',
    title: 'Press Pops',
    details: {
      client: 'Press Brothers Juicery',
      industry: 'Food & Beverage',
      services: [
        'Brand Strategy',
        'Brand Identity',
        'Packaging Design',
        'Web Design + Development',
        'Brand Collateral',
      ],
    },
    tags: [
      'Brand Messaging',
      'Brand Identity',
      'Packaging Design',
      'Website Design',
    ],
    color: '#626429',
    colors: ['#c2c824', '#626429'],
  },
  {
    listed: true,
    key: 'cbs',
    title: 'CBS TV App',
    details: {
      client: 'CBS Interactive',
      industry: 'Entertaiment',
      services: ['UX Design', 'Visual Design'],
    },
    tags: ['UX Design', 'Visual Design'],
    color: '#0f3b6c',
    colors: ['#2d8be5', '#0f3b6c'],
  },
  {
    listed: false,
    key: 'sungreen-systems',
    title: 'Sungreen Systems',
    details: {
      client: 'SunGreen Systems',
      agency: 'Atomic Tango',
      industry: 'Technology',
      services: ['Brand Strategy'],
    },
    tags: ['Brand Strategy', 'Website Design'],
    color: '#6d7900',
    colors: ['#88b301', '#5f2b03'],
  },
  {
    listed: true,
    key: 'rams',
    title: 'Los Angeles Rams',
    details: {
      client: 'Los Angeles Rams',
      industry: 'Sports & Entertaiment',
      services: ['Art Direction', 'Digital Advertising'],
    },
    tags: ['Art Direction', 'Digital Advertising'],
    color: '#001865',
    colors: ['#001865', '#001865'],
  },
  {
    listed: true,
    key: 'plum-lending',
    title: 'Plum Lending',
    headline: 'Marketing to the new adventurers',
    headlineMarkup: (
      <Fragment>
        <span>Marketing to</span>
        <br />
        <span>the new adventurers</span>
      </Fragment>
    ),
    details: {
      client: 'Plum Lending',
      industry: 'Financial',
      services: [
        'Brand Strategy',
        'Brand Messaging',
        'Brand Identity',
        'Marketing Planning',
        'Web Design + Development',
      ],
    },
    tags: [
      'Brand Strategy',
      'Brand Identity',
      'Web Design',
      'Marketing Planning',
    ],
    color: '#421690',
    colors: ['#009A00', '#72DB00'],
  },
]

export const listedProjects = projects.filter(p => p.listed)

export const projectURL = key => `/work/${key}`

export const getProject = key =>
  Array.prototype.find
    ? projects.find(p => p.key === key)
    : projects.filter(p => p.key === key)[0]

export const getPrevProject = key => {
  const currentProjectIndex = listedProjects.indexOf(getProject(key))
  return currentProjectIndex - 1 >= 0
    ? listedProjects[currentProjectIndex - 1]
    : listedProjects[listedProjects.length - 1]
}

export const getNextProject = key => {
  const currentProjectIndex = listedProjects.indexOf(getProject(key))
  return currentProjectIndex + 1 < listedProjects.length
    ? listedProjects[currentProjectIndex + 1]
    : listedProjects[0]
}
